/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DateRange } from 'react-date-range'

import { useDispatch, useSelector } from 'react-redux'
import { setOrderFilterData } from '../redux/slices/filter.slice'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

import moment from 'moment'
import { enUS } from 'date-fns/locale'

import { _object } from 'utils/interfaces'
import { routes } from 'utils/routes'
import { dateFormat, formatPaymentType, formatPrice, getStatusLabel } from 'utils'

import { brandsService } from 'services'
import { orderService } from 'services/order.service'
import { customersService } from 'services/customers.services'

import { Pagination } from 'components'

import { ViewIcon } from 'assets/svg'

const Orders = () => {
  const Orderstatus = [{ status: 'Open' }, { status: 'Close' }]
  const OrderPaymentTerm = [
    { label: 'Cash On Delivery', payment_term: 'CashOnDelivery' },
    { label: 'Pre Paid', payment_term: 'PrePaid' },
    { label: 'In Given Number Days', payment_term: 'InAGivenNumberOfDays' },
    { label: 'On Day Of The Month', payment_term: 'OnADayOfTheMonth' },
    { label: 'Number Of Days After EOM', payment_term: 'NumberOfDaysAfterEOM' },
    { label: 'Day Of Month After EOM  ', payment_term: 'DayOfMonthAfterEOM' }
  ]

  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  const [filterEntities, setFilterEntities] = useState<_object>({})
  const [showDatePicker, setShowDatePicker] = useState(false)
  const dispatch = useDispatch()

  const savedFilters = useSelector((state: _object) => state.filter.orderFilter)

  const [filters, setFilters] = useState(
    Object.keys(savedFilters || {}).length ? savedFilters : {
      q: '',
      page: 1,
      per_page: 25,
      sort: '-created_at',
      filters: { status: '', payment_term: '' }
    }
  )

  useEffect(() => {
    setLoading(true)
    setFilterEntities((prev) => ({
      ...prev,
      status: Orderstatus,
      payment_term: OrderPaymentTerm
    }))

    brandsService.getBrands({ per_page: 999 }).then((results: _object) => {
      setFilterEntities((prev) => ({
        ...prev,
        brands: results.items
      }))
    })

    customersService.getCustomers({ page: 1, per_page: 9999 }).then((results: _object) => {
      setFilterEntities((prev) => ({
        ...prev,
        customers: results.items
      }))
    })

    orderService.getOrders(filters).then((results) => {
      setResults(results)
      setLoading(false)
    })
  }, [filters])

  useEffect(() => {
    dispatch(setOrderFilterData(filters))
  }, [filters])

  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">
          Orders <small>Total records: {results?.pagination?.total_items}</small>
        </h1>
      </div>

      <div className="mb-4">
        <form>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <input
                type="search"
                placeholder="Search keyword"
                className="w-60 rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
                value={filters.q || ''}
                onChange={(e) => {
                  setFilters({ ...filters, q: e.target.value })
                }}
              />

              <div className="relative w-full">
                <select
                  name="status"
                  value={filters?.filters?.status || ''}
                  onChange={(e) =>
                    setFilters((prev: _object) => ({
                      ...prev,
                      filters: {
                        ...prev.filters,
                        status: e.target.value
                      }
                    }))
                  }
                  className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
                >
                  <option value="">All status</option>
                  {filterEntities?.status?.map((item: _object, i: number) => (
                    <option key={i} value={item.status}>
                      {item.status}
                    </option>
                  ))}
                </select>

                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
              <div className="relative w-full">
                <select
                  name="payment_term"
                  value={filters?.filters?.payment_term || ''}
                  onChange={(e) =>
                    setFilters((prev: _object) => ({
                      ...prev,
                      filters: {
                        ...prev.filters,
                        payment_term: e.target.value
                      }
                    }))
                  }
                  className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
                >
                  <option value="">All payment terms</option>
                  {filterEntities?.payment_term?.map((item: _object, i: number) => (
                    <option key={i} value={item.payment_term}>
                      {item.label}
                    </option>
                  ))}
                </select>

                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>

              <div className="relative w-full">
                <div
                  onClick={() => setShowDatePicker(!showDatePicker)}
                  className="h-[40px] w-60 cursor-pointer rounded-md border px-3 py-2 text-sm text-gray-500 outline-none focus:outline-none"
                >
                  <span className="text-black">
                    {filters.start_date && filters.end_date
                      ? `${moment(filters.start_date).format('MMM D, YYYY')} - ${moment(filters.end_date).format('MMM D, YYYY')}`
                      : 'choose Date'}
                  </span>
                  <span className="absolute top-3 right-2 z-10">
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </span>
                </div>

                {showDatePicker && (
                  <div className="absolute z-20 bg-white shadow-lg">
                    <DateRange
                      className=""
                      editableDateInputs={true}
                      onChange={(item: _object) => {
                        setFilters({
                          ...filters,
                          start_date: moment(item.selection.startDate).format('YYYY-MM-DD'),
                          end_date: moment(item.selection.endDate).format('YYYY-MM-DD')
                        })
                      }}
                      moveRangeOnFirstSelection={false}
                      ranges={
                        filters.start_date && filters.end_date
                          ? [
                            {
                              startDate: new Date(filters.start_date),
                              endDate: new Date(filters.end_date),
                              key: 'selection'
                            }
                          ]
                          : [
                            {
                              startDate: new Date(),
                              endDate: new Date(),
                              key: 'selection'
                            }
                          ]
                      }
                      locale={enUS}
                    />
                  </div>
                )}
              </div>

              <div className="relative w-full">
                <select
                  className="block w-[200px] w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
                  name="customers"
                  value={filters.user_id || ''}
                  onChange={(e) => {
                    setFilters({ ...filters, user_id: e.target.value })
                  }}
                >
                  <option value="">All customers</option>
                  {filterEntities?.customers?.map((item: _object, i: number) => {
                    if (item?.is_active) {
                      return (
                        <option key={i} value={item.id}>
                          {item.full_name}
                        </option>
                      )
                    }
                    return null
                  })}
                </select>

                {/* <Select
                  onChange={(e: any) => {
                    setFilters({ ...filters, user_id: e.value })
                  }}
                  options={filterEntities?.customers?.map((item: _object) => ({
                    value: item?.id,
                    label: item?.full_name
                  }))}
                  className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
                /> */}

                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>

              <button
                type="button"
                className="flex px-3 py-1 text-sm font-medium whitespace-nowrap text-red-600 underline"
                onClick={() => {
                  setFilters({ per_page: 25 })
                }}
              >
                Clear filters
              </button>
            </div>{' '}
          </div>
        </form>
      </div>

      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold whitespace-nowrap">#</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Order Id</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Customer</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Shipping Address</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Status</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Order Note</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Payment Term</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Order Date</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Payment Due Date</th>
              <th className="px-4 py-3 font-semibold whitespace-nowrap">Total</th>
              <th className="px-4 py-3 text-center font-semibold whitespace-nowrap">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => (
                <tr className="hover:bg-gray-50" key={i}>
                  <td className="px-4 py-3"> {(filters.page - 1) * filters.per_page + i + 1}</td>
                  <td className="px-4 py-3">{item?.order_number}</td>
                  <td className="px-4 py-3">
                    {item?.user?.first_name} {item?.user?.last_name}
                  </td>
                  <td className="px-4 py-3">
                    {' '}
                    {item?.shipping?.address1}, {item?.shipping?.address2},{item?.shipping?.city},
                    {item?.shipping?.country},{item?.shipping?.state}, phone number
                    {item?.shipping?.postcode},{item?.shipping?.phone}
                  </td>
                  <td className="px-4 py-3">{getStatusLabel(item?.status)}</td>
                  <td className="px-4 py-3">{item?.order_note}</td>

                  <td className="px-4 py-3">{formatPaymentType(item?.payment_term)}</td>
                  <td className="px-4 py-3">{dateFormat(item?.created_at)}</td>
                  <td className="px-4 py-3">{dateFormat(item?.payment_due_date)}</td>
                  <td className="px-4 py-3">{formatPrice(item?.total)}</td>
                  <td className="text-center px-4 py-3">
                    <button type="button" className="" title="view details">
                      <Link to={`${routes.orders}/${item.id}`}>
                        <ViewIcon />
                      </Link>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <OrderSkeleton />
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>
            }
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}
    </>
  )
}

export default Orders

const OrderSkeleton = () => {
  return (
    <tr className="animate-pulse">
      <td className="px-4 py-3">
        <div className="h-4 w-6 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-32 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-12 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-8 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-24 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-20 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-20 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-20 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-20 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-20 rounded bg-gray-300"></div>
      </td>
      <td className="flex justify-center gap-2 px-4 py-3">
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
      </td>
    </tr>
  )
}
